<template>
  <footer class="kbx-form-footer">
    <div
      klickbox-edit-item="button"
      klickbox-edit-label="Botão Próximo"
      :klickbox-edit-label="$t('edit.canvas.next_button')"
      klickbox-internal-style="kbx-btn-submit-form"
      class="kbx-btn"
      style="min-width: 100px; overflow: visible"
      v-show="showButton()"
      :style="stepStyle('button')">
      {{ stepPreview.next_button_text || $t('general.labels.next') }}
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    stepStyle: 'stepStyle',
    stepPreview: 'stepPreview',
  }),
  methods: {
    hasOther() {
      if (!this.stepPreview.options) {
        return false;
      }

      return !!this.stepPreview.options.filter(option => option.other).length;
    },
    showButton() {
      if (this.stepPreview.final || this.stepPreview.kind === 'email') {
        return false;
      }

      if (this.stepPreview.multiple_answers || this.hasOther()) {
        return true;
      }

      if (this.stepPreview.isGeneral || this.stepPreview.kind === 'text') {
        return true;
      }

      return false;
    },
    onChange(text) {
      this.$store.dispatch('stepUpdateNextButtonText', {
        event: { target: { value: text } },
        id: this.stepPreview.id,
      });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** ButtonNext.vue?63da4a1e
 **/